import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

type TProps = {
	align?: 'center' | 'left' | 'right';
	className?: string;
	title: ReactNode;
}

const TextSeparator = ({ title, className, align = 'left' }: TProps) => (
	<div className='relative'>
		<div className='absolute inset-0 flex items-center'>
			<span className='w-full border-t'></span>
		</div>
		<div
			className={cn(
				'relative flex text-sm',
				align === 'left' && 'justify-start',
				align === 'center' && 'justify-center',
				align === 'right' && 'justify-end'
			)}>
			<span
				className={cn(
					'bg-card text-muted-foreground',
					align === 'left' && 'pr-3',
					align === 'center' && 'px-3',
					align === 'right' && 'pl-3',
					className
				)}>
				{title}
			</span>
		</div>
	</div>
);

export default TextSeparator;
